document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('alertThenRedirectModal');
    if (!modal) return;

    const redirect = modal.dataset.redirect;
    const redirectAfter = parseInt(modal.dataset.redirectAfter, 10);

    setTimeout(function () {
        window.location.href = redirect;
    }, redirectAfter * 1000);
});
